export default __webpack_public_path__ + "static/media/1889.683ba1cc.png";